export class AbstractRealtimeComponent {
    onCallHold() {
        this.reset();
    }
    onCallEnd() {
        this.reset();
    }
}
